"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingMixinPropTypes = exports.paddingMixin = exports.padMyChildrenMixin = exports.noMarginLastChild = exports.marginMixinPropTypes = exports.marginMixin = exports.getPaddingPropValue = exports.getPaddingFromProps = exports.getMarginPropValue = exports.getMarginFromProps = exports.flexContainerMixin = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _helpers = require("../helpers");
var _base = require("../themes/_base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var paddingMixinPropTypes = {
  /* String for all paddings */
  p: _propTypes["default"].oneOf(_base.spaceTypes),
  /* Vertical paddings */
  pV: _propTypes["default"].oneOf(_base.spaceTypes),
  /* Horizontal paddings */
  pH: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Padding Top */
  pT: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Padding Bottom */
  pB: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Padding Right */
  pR: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Padding Left */
  pL: _propTypes["default"].oneOf(_base.spaceTypes)
};
exports.paddingMixinPropTypes = paddingMixinPropTypes;
var paddingMixin = function paddingMixin() {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ";", ";", ""], function (props) {
    return props.p && (0, _styledComponents.css)(["padding:", ";"], props.theme.spaces[props.p]);
  }, function (props) {
    return props.pV && (0, _styledComponents.css)(["padding-top:", ";padding-bottom:", ";"], props.theme.spaces[props.pV], props.theme.spaces[props.pV]);
  }, function (props) {
    return props.pH && (0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], props.theme.spaces[props.pH], props.theme.spaces[props.pH]);
  }, function (props) {
    return props.pT && (0, _styledComponents.css)(["padding-top:", ";"], props.theme.spaces[props.pT]);
  }, function (props) {
    return props.pB && (0, _styledComponents.css)(["padding-bottom:", ";"], props.theme.spaces[props.pB]);
  }, function (props) {
    return props.pR && (0, _styledComponents.css)(["padding-right:", ";"], props.theme.spaces[props.pR]);
  }, function (props) {
    return props.pL && (0, _styledComponents.css)(["padding-left:", ";"], props.theme.spaces[props.pL]);
  });
};
exports.paddingMixin = paddingMixin;
var padMyChildrenMixin = function padMyChildrenMixin(child) {
  return (0, _styledComponents.css)(["", "{padding:", ";", ";}"], child, function (props) {
    return props.theme.spaces.base;
  }, paddingMixin);
};
exports.padMyChildrenMixin = padMyChildrenMixin;
var marginMixinPropTypes = {
  /* String for all margins */
  m: _propTypes["default"].oneOf(_base.spaceTypes),
  /* Vertical margins */
  mV: _propTypes["default"].oneOf(_base.spaceTypes),
  /* Horizontal margins */
  mH: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Margin Top */
  mT: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Margin Bottom */
  mB: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Margin Right */
  mR: _propTypes["default"].oneOf(_base.spaceTypes),
  /*  Margin Left */
  mL: _propTypes["default"].oneOf(_base.spaceTypes)
};
exports.marginMixinPropTypes = marginMixinPropTypes;
var marginMixin = function marginMixin() {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " ", " ", ""], function (props) {
    return props.m && (0, _styledComponents.css)(["margin:", ";"], props.theme.spaces[props.m]);
  }, function (props) {
    return props.mV && (0, _styledComponents.css)(["margin-top:", ";margin-bottom:", ";"], props.theme.spaces[props.mV], props.theme.spaces[props.mV]);
  }, function (props) {
    return props.mH && (0, _styledComponents.css)(["margin-left:", ";margin-right:", ";"], props.theme.spaces[props.mH], props.theme.spaces[props.mH]);
  }, function (props) {
    return props.mT && (0, _styledComponents.css)(["margin-top:", ";"], props.theme.spaces[props.mT]);
  }, function (props) {
    return props.mB && (0, _styledComponents.css)(["margin-bottom:", ";"], props.theme.spaces[props.mB]);
  }, function (props) {
    return props.mL && (0, _styledComponents.css)(["margin-left:", ";"], props.theme.spaces[props.mL]);
  }, function (props) {
    return props.mR && (0, _styledComponents.css)(["margin-right:", ";"], props.theme.spaces[props.mR]);
  });
};
exports.marginMixin = marginMixin;
var noMarginLastChild = function noMarginLastChild(props) {
  return props.noMarginLastChild && (0, _styledComponents.css)(["> *:last-child{margin-bottom:0;}"]);
};
exports.noMarginLastChild = noMarginLastChild;
var flexContainerMixin = function flexContainerMixin(_ref) {
  var _ref$defaultAlignItem = _ref.defaultAlignItems,
    defaultAlignItems = _ref$defaultAlignItem === void 0 ? "center" : _ref$defaultAlignItem,
    _ref$defaultJustifyCo = _ref.defaultJustifyContent,
    defaultJustifyContent = _ref$defaultJustifyCo === void 0 ? "center" : _ref$defaultJustifyCo;
  return (0, _styledComponents.css)(["display:flex;flex-direction:", ";align-items:", ";justify-content:", ";", ";", ";", ";", ";", ";", ";", ";"], function (props) {
    return props.direction || "row";
  }, function (props) {
    return props.alignItems || defaultAlignItems;
  }, function (props) {
    return props.justifyContent || defaultJustifyContent;
  }, function (props) {
    return props.shrink && (0, _styledComponents.css)(["flex-shrink:", ";"], props.shrink === true ? "1" : props.shrink);
  }, function (props) {
    return props.grow && (0, _styledComponents.css)(["flex-grow:", ";"], props.grow === true ? "1" : props.grow);
  }, function (props) {
    return props.wrap && (0, _styledComponents.css)(["flex-wrap:", ";"], props.wrap);
  }, function (props) {
    return props.width && (0, _styledComponents.css)(["width:", ";"], props.width);
  }, function (props) {
    return props.height && (0, _styledComponents.css)(["height:", ";"], props.height);
  }, function (props) {
    return props.gap && (0, _styledComponents.css)(["gap:", ";"], (0, _helpers.getSpace)(props, "gap", "base"));
  }, function (props) {
    return props.gapV && (0, _styledComponents.css)(["row-gap:", ";"], (0, _helpers.getSpace)(props, "gapV", "base"));
  });
};

/** This function gets the correct padding in pixels for a side, given and object with padding props.
 *
 * @param {Object} props The props of the styled component. Are expected to contain the theme and one or more of the padding props: "p", "pV", "pH", "pL", "pR", "pT", "pB"
 * @param {String} side The side we are computing the padding for. One of "left", "right", "top", "bottom"
 * @param {String} fallback What value should be used as a fallback, in case there is no padding found in props for the specified side
 * @returns {String} the pixel value for the padding, taken from theme spaces or an empty string
 */
exports.flexContainerMixin = flexContainerMixin;
var getPaddingPropValue = function getPaddingPropValue(props) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
  var fallback = arguments.length > 2 ? arguments[2] : undefined;
  // get a padding prop value if one is passed in
  var padding = "";
  switch (side) {
    case "left":
      padding = props.pL || props.pH || props.p;
      break;
    case "right":
      padding = props.pR || props.pH || props.p;
      break;
    case "bottom":
      padding = props.pB || props.pV || props.p;
      break;
    case "top":
    default:
      padding = props.pT || props.pV || props.p;
  }
  return padding ? props.theme.spaces[padding] : fallback ? props.theme.spaces[fallback] : "";
};

/** This function gets the correct margin in pixels for a side, given and object with margin props.
 *
 * @param {Object} props The props of the styled component. Are expected to contain the theme and one or more of the margin props: "m", "mV", "mH", "mL", "mR", "mT", "mB"
 * @param {String} side The side we are computing the margin for. One of "left", "right", "top", "bottom"
 * @param {String} fallback What value should be used as a fallback, in case there is no margin found in props for the specified side
 * @returns {String} the pixel value for the margin, taken from theme spaces or an empty string
 */
exports.getPaddingPropValue = getPaddingPropValue;
var getMarginPropValue = function getMarginPropValue(props) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
  var fallback = arguments.length > 2 ? arguments[2] : undefined;
  var margin = "";
  switch (side) {
    case "left":
      margin = props.mL || props.mH || props.m;
      break;
    case "right":
      margin = props.mR || props.mH || props.m;
      break;
    case "bottom":
      margin = props.mB || props.mV || props.m;
      break;
    case "top":
    default:
      margin = props.mT || props.mV || props.m;
  }
  return margin ? props.theme.spaces[margin] : fallback ? props.theme.spaces[fallback] : "";
};

/**
 * Function used to set the default paddings for an element, given an object of props.
 *
 * @param {Object} props only the theme is required from this object
 * @param {Object} propsObject an object that contains padding props that we want to use (p, pV, pH, etc.). For example this would be an object set in the theme like "layoutDefaults"
 * @returns {String} css for padding-top, padding-bottom, etc.
 */
exports.getMarginPropValue = getMarginPropValue;
var getPaddingFromProps = function getPaddingFromProps(props, propsObject) {
  return (0, _styledComponents.css)(["padding-top:", ";padding-left:", ";padding-right:", ";padding-bottom:", ";"], getPaddingPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "top"), getPaddingPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "left"), getPaddingPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "right"), getPaddingPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "bottom"));
};

/**
 * Function used to set the default margins for an element, given an object of props.
 *
 * @param {Object} props only the theme is required from this object
 * @param {Object} propsObject an object that contains margin props that we want to use (p, pV, pH, etc.). For example this would be an object set in the theme like "layoutDefaults"
 * @returns {String} css for margin-top, margin-bottom, etc.
 */
exports.getPaddingFromProps = getPaddingFromProps;
var getMarginFromProps = function getMarginFromProps(props, propsObject) {
  return (0, _styledComponents.css)(["margin-top:", ";margin-left:", ";margin-right:", ";margin-bottom:", ";"], getMarginPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "top"), getMarginPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "left"), getMarginPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "right"), getMarginPropValue(_objectSpread({
    theme: props.theme
  }, propsObject), "bottom"));
};
exports.getMarginFromProps = getMarginFromProps;